import Vue from 'vue'

const document = {
  state: {
    documents: [],
    selectedDocument: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    documents(state) {
      return state.documents
    },
    selectedDocument(state) {
      return state.selectedDocument
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    documents(state, payload) {
      state.documents = payload
    },
    selectedDocument(state, payload) {
      state.selectedDocument = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedDocument(context, payload) {
      context.commit('selectedDocument', payload)
    },
    loadDocuments(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Document'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('documents', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedDocument(context, payload) {
      if (context.state.selectedDocument && context.state.selectedDocument.Id) {
        context.dispatch(
          'loadSelectedDocument',
          context.state.selectedDocument.Id
        )
      }
    },
    loadSelectedDocument(context, payload) {
      if (
        context.state.selectedDocument &&
        context.state.selectedDocument.Id != payload
      ) {
        context.commit('selectedDocument', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'Document/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedDocument', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadDocuments(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadDocuments')
      })
    },
    updateDocument(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Document/${payload.Id}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'document updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDocuments')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createDocument(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Document`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'document created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDocuments')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveDocument(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.Id > 0) {
          context.dispatch('updateDocument', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createDocument', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteDocument(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Document/${payload.Id}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'document deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDocuments')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default document
